import { useQuery } from '@tanstack/react-query';
import { supabase } from '../utils/supabaseClient';
import { queryKeys } from '../utils/queryKeys';

const fetchTickerText = async () => {
  try {
    const { data, error } = await supabase
      .from("ticker_texts")
      .select("ticker_text")
      .eq("id", 1)
      .single();

    if (error) throw error;
    return data?.ticker_text;
  } catch (error) {
    throw error;
  }
};

export function useHomeData() {
  const { data: tickerText, error } = useQuery({
    queryKey: queryKeys.ticker.byId(1),
    queryFn: fetchTickerText,
    staleTime: 1000 * 60 * 5, // 5 minutos
    cacheTime: 1000 * 60 * 30, // 30 minutos
    retry: 2
  });

  return {
    tickerText: tickerText || "Discover the latest projects before they launch.",
    error
  };
}